import React from "react";

/**
 * Form fields for user create/edit. Pure controlled component.
 */
export function UserForm({ form, set, isCreate }) {
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
                <label className="label-tu">Rôle</label>
                <select
                    data-testid="user-modal-role"
                    value={form.role}
                    onChange={(e) => set("role", e.target.value)}
                    className="input-tu"
                >
                    <option value="admin">Admin</option>
                    <option value="club">Club</option>
                    <option value="sponsor">Sponsor</option>
                </select>
            </div>
            <div>
                <label className="label-tu">Statut</label>
                <select
                    data-testid="user-modal-status"
                    value={form.status}
                    onChange={(e) => set("status", e.target.value)}
                    className="input-tu"
                >
                    <option value="approved">approved</option>
                    <option value="pending">pending</option>
                    <option value="rejected">rejected</option>
                </select>
            </div>
            <div>
                <label className="label-tu">Nom / Raison sociale</label>
                <input data-testid="user-modal-name" value={form.name} onChange={(e) => set("name", e.target.value)} className="input-tu" />
            </div>
            <div>
                <label className="label-tu">Email</label>
                <input data-testid="user-modal-email" type="email" value={form.email} onChange={(e) => set("email", e.target.value)} className="input-tu" />
            </div>
            <div>
                <label className="label-tu">Téléphone (FR 10 chiffres)</label>
                <input data-testid="user-modal-phone" value={form.phone} onChange={(e) => set("phone", e.target.value)} placeholder="06 12 34 56 78" className="input-tu" />
            </div>
            {form.role === "sponsor" && (
                <div>
                    <label className="label-tu">SIREN (9 chiffres)</label>
                    <input data-testid="user-modal-siren" value={form.siren} onChange={(e) => set("siren", e.target.value.replace(/[^0-9 ]/g, ""))} placeholder="123 456 789" className="input-tu" />
                </div>
            )}
            <div className={form.role === "sponsor" ? "" : "md:col-span-2"}>
                <label className="label-tu">
                    Mot de passe {isCreate ? "(requis, 6+ car.)" : "(laisser vide pour ne pas changer)"}
                </label>
                <input
                    data-testid="user-modal-password"
                    type="password"
                    value={form.password}
                    onChange={(e) => set("password", e.target.value)}
                    placeholder={isCreate ? "" : "•••••• (inchangé)"}
                    className="input-tu"
                />
            </div>
        </div>
    );
}
